import ChargebeeAddonsDictionary from 'Dictionaries/chargebee/ChargebeeAddonsDictionary';
//todo maybe use catalogue to have optionsList
const optionsList = ['pack_stock', 'pack_support', 'pack_cashflow', 'pack_marketing'];
const licensesList = [
    'pack_all_included_full',
    'pack_prospecting_sale_full',
    'pack_invoicing_management_full',
];
const subOptionsList = [
    'pack_marketing_custom_domain',
    'pack_marketing_multi_domains_auth',
    'pack_marketing_dedicated_ip',
    'pack_marketing_email',
];

const regexForNameKeyAndStatus = () => {
    return new RegExp(/^(?<nameKey>.+)_(?<status>full|discount|free)(?:_yearly|_monthly)?$/);
};
const getNameKeyAndStatus = (itemId) => {
    const match = itemId.match(regexForNameKeyAndStatus());
    const regexLevelOption = /_(starter|pro|business)\b/;
    if (match?.groups?.nameKey.match(regexLevelOption)) {
        match.groups.nameKey = match?.groups?.nameKey.replace(regexLevelOption, '');
    }
    return match?.groups ?? { nameKey: '', status: '' };
};
const getStatusForDiscountedItem = (itemId, discount) => {
    if (!discount) {
        return;
    }
    if (discount.type === 'percentage' && discount.percentage === 100) {
        return 'free';
    } else {
        return 'discount';
    }
};

/**
 * Get the plan based on the chargebee id plan name. Necessary for the form.
 * @param {string} plan : id from chargebee
 * @returns {string} : the actual name of the plan
 */
const getPlanDatas = (plan) => {
    const plans =
        window.sellsyapp.config.globalProperties.$store.state.subscriptionManager.versionedPlans;
    const planIdExploded = plan.split('_');
    const type = planIdExploded[2];
    return plans.find((plan) => plan.code === type);
};
const findItemById = (id, list, callback) => {
    if (typeof list === 'object' && list.id && list.id === id) {
        callback(list);
    } else {
        if (typeof list === 'object') {
            list = Object.values(list);
            if (list.length > 0) {
                for (const item of list) {
                    if (item === id) {
                        callback(item);
                    } else {
                        findItemById(id, item, callback);
                    }
                }
            }
        }
    }
};

const getLabel = (addon) => {
    let id = addon.item_price_id ?? addon.id;
    if (addon.item_type === 'plan') {
        return { label: getPlanDatas(id)?.label };
    } else {
        //Id exemple pack_marketing_email_pro_full_monthly, we have to remove the 2 last word because they're dynamic
        id = id.split('_');
        id = id.slice(0, id.length - 2);
        id = id.join('_');
    }
    return ChargebeeAddonsDictionary[id] ?? {};
};
const isOption = (item) => optionsList.includes(item.nameKey);
const isSubOption = (item) => subOptionsList.includes(item.nameKey);
const updateSubscriptionAddonsPrice = ({ subscriptionItems, discounts }) => {
    for (let subscriptionItem of subscriptionItems) {
        subscriptionItem.amount = subscriptionItem.unit_price * subscriptionItem.quantity;
        subscriptionItem = applyDiscount({ subscriptionItem, discounts });
    }
    return subscriptionItems;
};
const applyDiscount = ({ subscriptionItem, discounts }) => {
    subscriptionItem.amount -= calculateDiscount({ subscriptionItem, discounts });
    return subscriptionItem;
};
const calculateDiscount = ({ subscriptionItem, discounts }) => {
    let discountAmount = 0;
    try {
        const discount = discounts.find(
            (subscriptionDiscount) =>
                subscriptionDiscount.item_price_id === subscriptionItem.item_price_id &&
                subscriptionItem.quantity > 0,
        );
        if (discount) {
            if (discount.type === 'fixed_amount') {
                discountAmount = discount.amount;
            } else {
                discountAmount =
                    ((subscriptionItem.unit_price * discount.percentage) / 100) *
                    subscriptionItem.quantity;
            }
        }
    } catch (e) {
        window.sellsyapp.config.globalProperties.$store.state.system.errorsHandler.logException(e);
    } finally {
        return discountAmount;
    }
};
const newOptionLevelItem = (data, labels) => {
    const itemPriceId = data.id ?? data.item_price_id;
    return {
        amount: data.price ?? data.amount,
        item_price_id: itemPriceId,
        item_type: 'addon',
        nameKey: data.nameKey,
        quantity: data.quantity ?? 1,
        newItem: data.newItem,
        updatedQuantity: data?.newItem ? 1 : 0,
        status: data.newItem ? 'full' : 'modified',
        unit_price: data.price ?? data.unit_price,
        label: getLabel({ item_price_id: itemPriceId })?.label ?? labels[data.nameKey],
    };
};
export {
    regexForNameKeyAndStatus,
    getNameKeyAndStatus,
    getStatusForDiscountedItem,
    optionsList,
    licensesList,
    isOption,
    findItemById,
    getPlanDatas,
    getLabel,
    updateSubscriptionAddonsPrice,
    applyDiscount,
    calculateDiscount,
    isSubOption,
    newOptionLevelItem,
};
